export const tradingContest = {
    cyjyds: "İşlem Yarışmasına Katıl",
    jsjxmh: "Sürpriz kutuyu aç, süper ödüller kazan!",
    hdsj: "Etkinlik zamanı",
    mrjxsj: "Her gün 00:00 - 23:59 UTC+8 arası.",
    ckxxgz: "Detaylı kuralları görüntüle",
    wdjj: "Ödüllerim",
    jlkj: "Çekilişe kalan süre",
    cjjc: "Süper ödül havuzu",
    jjmrzj: "Ödüller günlük olarak birikir",
    kqxjd: "Yeni aşama başlar, ödül miktarı artar",
    dyjd: "Birinci aşama",
    dejd: "İkinci aşama",
    dsjd: "Üçüncü aşama",
    dsijd: "Dördüncü aşama",
    jrmhjj: "Günlük sürpriz kutu ödülü",
    syjj: "Kalan ödül",
    yblqje: "Talep edilen ödül",
    tjmh: "Özel kutu",
    yjmh: "Birinci seviye kutu",
    ejmh: "İkinci seviye kutu",
    sjmh: "Üçüncü seviye kutu",
    jj: "Ödül:",
    gs: "adet",
    djdkrymh: "Sürpriz kutulardan birini açmak için tıkla",
    kydk: "Bugün açabilirsiniz",
    jxmh: "Sürpriz kutu",
    dkmhxyxx: "Bir kutu açmak için {amount} yıldız gerekir.",
    xzyyxx: "Şu an {amount} yıldızınız var",
    xxqlsj: "Yıldız sıfırlama zamanı: {date} (Lütfen sıfırlanmadan önce kutuları açın)",
    wdxx: "Yıldızlarım",
    xxhq: "Yıldız kazanma",
    hqxxtj: "Yıldız kazanma yolları",
    yxhysxf: "Süresiz kontrat: {amount}U işlem ücreti başına 1 yıldız",
    qqhysxf: "Opsiyon kontrat: {amount}U işlem hacmi başına 1 yıldız",
    youxihysxf: "GameFi: {amount}U işlem hacmi başına 1 yıldız",
    gxhd: "Tebrikler, kazandınız",
    jlydrzh: "Bu ödül {account} hesabınıza yatırıldı",
    qzjzhck: "Fun Invest hesabını kontrol et",
    bwcjjc: "BiKing Süper Ödül Havuzu",
    qmxjyds: "All-Star İşlem Yarışması",
    gbgbyb: "Risk almaya hazır mısın?",
    bwcjjcdnn: "BiKing Süper Ödül Havuzu, günlük {amount}% sürpriz kutu ödülü seni bekliyor!",
    cjjcqmxjys: "BiKing Süper Ödül Havuzu All-Star Yarışması {amount}% günlük sürpriz kutu ekler,",
    syyxbd: "Küçük bir şansla büyük kazan!",
    zgtk: "Zirveye çıkmak ister misin? Hadi mücadele edelim!",
    zhyz: "Günlük ödül havuzunun {amount}%'si son mücadeleye birikir,",
    dfdj: "BiKing zirve ödülünü kim alacak?",
    gsjj: "BiKing Süper Ödül Havuzu All-Star Yarışması'nda ustalar toplanıyor,",
    qmxpk: "All-Star mücadelesi gerçekleri ortaya çıkarır!",
    jymh: "İşlem, sürpriz kutular, sıralama - BiKing arenasında eğlen!",
    zzbzy: "Süresiz kontrat, opsiyon, GameFi, spot işlem - dört haftalık oyun tarzı kademeli olarak yükseliyor, her hafta farklı!",
    jlfh: "BiKing Süper Ödül Havuzu All-Star İşlem Yarışması, zengin ödüllerle şöhret ve servet seni bekliyor!",
    mh: "Sürpriz kutu",
    cb: "Sıralama",
    jy: "İşlem",
    syxxs: "Kalan yıldız sayısı",
    xxbhs: "Yıldız değişim miktarı",
    sjlx: "Olay türü",
    jycp: "İşlem ürünü",
    jye: "İşlem hacmi",
    myxgjl: "Henüz ilgili ödül almadınız",
    jyhd: "İşlemle kazanıldı",
    ql: "Sıfırla",
    kqmh: "Kutu aç",
    yx: "GameFi oyunu",
    bchdyjs: "Bu etkinlik sona erdi",
    gffjj: "Yarışmada toplam ödül dağıtıldı",
    kqmhsl: "Açılan kutu sayısı",
    cjjcjj: "Süper ödül havuzu ödülü",
    cjjchjmd: "Süper ödül havuzu kazananları",
    jjdyyh: "Ödüller kullanıcı fon hesabına yatırıldı",
    hdjj: "Kazanılan ödül",
    wff: "Dağıtılmadı",
    mhhjjl: "Sürpriz kutu kazanç kaydı",
    cjdjhjjl: "Süper ödül kazanç kaydı",
    jjse: "Ödül miktarı",
    xhxxs: "Harcanan yıldız sayısı",
    bwqmxgz: "BiKing All-Star İşlem Yarışması Kuralları",
    hdnr: "Etkinlik içeriği",
    hdnrgz: "BiKing Süper Ödül Havuzu All-Star İşlem Yarışması, süresiz kontrat, opsiyon kontrat, GameFi oyunları ve spot işlem olmak üzere dört ana alanı kapsar. Etkinlik dört haftaya bölünmüştür ve her hafta yeni işlem ürünlerinin kilidini açarak çok boyutlu işlem zorluklarında 'yıldız' kazanmanızı ve zengin ödüller elde etmenizi sağlar. Günlük ödül havuzunun {total}%'si sürpriz kutu çekilişi için ayrılır, sürpriz ödüller anında kazanılır! Kalan {amount}% yarışma sonuna kadar birikir ve işlem sıralamasına göre en yüksek ödüller paylaşılır!",
    hdjd: "Etkinlik aşamaları",
    jbjs: "Kademeli kilitleme, dört dönemde rekabet yükseliyor",
    dyzq: "İlk dönem",
    kqyxhy: "Süresiz kontrat işlemini başlat, işlem hacmi arttıkça yıldız puanları ve ödül havuzu büyür!",
    dezq: "İkinci dönem",
    jmqqjy: "Opsiyon kontrat işlemi eklenir, kâr/zarar iki yönlü ödül havuzuna katkı sağlar, yıldız sayınızı artırın.",
    dszq: "Üçüncü dönem",
    cjgejc: "GameFi oyunları eklenir, çoklu işlem deneyimiyle yıldız kazanın ve yüksek ödül havuzuna ulaşın.",
    dsizq: "Dördüncü dönem",
    gfzzdj: "İlk üç haftanın sürpriz kutu ödülleri devam eder, spot işlem için ayrı liderlik tablosu oluşturulur, nihai büyük ödülü paylaşın!",
    jzszjs: "Ödül havuzu hesaplaması",
    jxmhgz1: "Günlük ödül havuzunun {amount}%'si sürpriz kutulara ayrılır, 100 kutu anında açılır ve dört seviyedeki ödüllerle sürekli sürpriz yaşarsınız. Talep edilmeyen ödüller otomatik olarak ertesi günün havuzuna eklenir, kazançlar büyümeye devam eder! Özel kutu, birinci seviye kutu vb. günlük yenilenir, yüksek kazanma şansı sizi bekliyor!",
    mhfpmx: "Günlük toplam {total} kutu, ödül havuzunun {amount}%'sini oluşturur. Kutu dağılım detayları:",
    tjmhzb: "Özel kutu {total} adet, ödül havuzunun {amount}%'si",
    yjmhzb: "Birinci seviye kutu {total} adet, ödül havuzunun {amount}%'si",
    ejmhzb: "İkinci seviye kutu {total} adet, ödül havuzunun {amount}%'si",
    sjmhzb: "Üçüncü seviye kutu {total} adet, ödül havuzunun {amount}%'si",
    kmhxxyq: "Kutu açmak için gereken yıldız sayısı: Günlük sürpriz kutu ödül miktarı/{text}",
    tips: "Not: Tüm sürpriz kutu ödülleri günlük 00:00'da yenilenir, önceki günün kâr/zararından oluşan ödül havuzu + önceki günden kalan kutu bakiyesiyle yeniden hesaplanır ve yukarıdaki seviye ve oranlara göre günlük kutulara dağıtılır.",
    mrjyyk: "Toplam ödül havuzu süresiz kontrat, opsiyon kontrat, GameFi olmak üzere üç ana bölümün günlük işlem kâr/zararına göre belirlenir.",
    mgyld: "Her kazançlı işlemin {amount}%'si = kazanç miktarı * {amount}%",
    mrjcljdjs: "Günlük ödül havuzunun {amount}%'si etkinlik sonuna kadar birikir ve dört işlem ürününün liderlik tablosundaki ilk üçe göre dağıtılır, dağıtım oranları: süresiz kontrat %40, opsiyon %30, GameFi %20, spot %10.",
    yhhyyld: "Örnek: Kullanıcı kontrat emri 1000U kâr ederse, 1000*{amount}%={total}U günlük ödül havuzuna eklenir",
    mgksd: "Her kayıplı işlemin {amount}%'si = gerçek kayıp miktarı (kayıp - likidasyon geri ödemesi) * {amount}%",
    yhhyks: "Örnek: Kullanıcı kontrat emri 1000U kaybederse, 1000*{amount}%={total}U günlük ödül havuzuna eklenir",
    qqhyyld: "Her kazançlı işlemin {amount}%'si = bahis miktarı * oran * {amount}%",
    qqyhddtz: "Örnek: Kullanıcı opsiyon emri 100U bahis yapar, 10 saniyede kazanırsa, 100 * 65%*{amount}%={total}U günlük ödül havuzuna eklenir",
    qqhyksd: "Her kayıplı işlemin {amount}%'si = kayıp miktarı * {amount}%",
    yhksjrjc: "Örnek: Kullanıcı opsiyon emri 100U kaybederse, 100*{amount}%={total}U günlük ödül havuzuna eklenir",
    yxyld: "Her kazançlı işlemin {amount}%'si = bahis miktarı * oran * {amount}%",
    yxddtz: "Örnek: Kullanıcı gamefi emri 100U bahis yapar, oran 2x varsayılır. Kazanırsa, 100 * 200%*{amount}%={total}U günlük ödül havuzuna eklenir",
    yxmgksd: "Her kayıplı işlemin {amount}%'si = kayıp miktarı * {amount}%",
    yhqqksd: "Örnek: Kullanıcı opsiyon emri 100U kaybederse, 100*{amount}%={total}U günlük ödül havuzuna eklenir",
    daiding: "Karar verilmedi",
    yytz: "Etkinlik ayarlaması",
    kaiqi: "Başlat",
    xhjyjrpm: "Spot işlem sıralamaya eklenir",
    drjy: "Günlük işlemler, ertesi gün ödül alır",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/tr.js